import React, { useMemo } from 'react';
import { List, PlusCircle } from 'react-bootstrap-icons';
import { isClient } from '../../../../helpers/global';
import { Button } from 'react-bootstrap';
import ServiceCardTaskCard from '../../../tasks/ServiceCardTaskCard';

const Tasks = ({
  tasks = [],
  onAddClick,
  onEditClick,
  onTaskDelete,
  onTaskStatusUpdate,
  fromDetails = false,
  style = {}
}) => {
  const role = useMemo(() => localStorage.getItem('user-role'), []);
  return (
    <div className="card p-3 h-100" style={style}>
      <div className="d-flex justify-content-between align-items-center h-100">
        <h6 className="ml-1 largeFont my-2 font-weight-bold">Tasks</h6>
        <div className="d-flex justify-content-end align-items-center">
          {!isClient(role) && tasks.length > 0 && (
            <div className="d-flex justify-content-between align-items-center">
              <Button className="d-flex align-items-center" variant="success" size="sm" onClick={onAddClick}>
                <PlusCircle size={12} className="mr-1" /> New Task
              </Button>
            </div>
          )}
        </div>
      </div>
      <div className="mt-1">
        {tasks.length > 0 ? (
          [...tasks]
            .sort((a, b) => {
              const aComplete = a.status === 'Complete';
              const bComplete = b.status === 'Complete';
              if (aComplete !== bComplete) return aComplete ? 1 : -1;
              return new Date(a.dueDate) - new Date(b.dueDate);
            })
            .map(task => (
              <ServiceCardTaskCard
                key={task?._id}
                task={task}
                fromDetails={fromDetails}
                onEditClick={() => onEditClick(task)}
                onStatusUpdate={onTaskStatusUpdate}
                onTaskDelete={onTaskDelete}
              />
            ))
        ) : (
          <>
            <p className="text-secondary midFont my-1">{'No tasks to show!'}</p>
            <hr className="my-2" />
            {!isClient(role) && (
              <div className=" d-flex text-center  justify-content-center">
                <Button
                  style={{ fontSize: 16 }}
                  className="my-4 mb-5 d-flex align-items-center"
                  variant="success"
                  onClick={onAddClick}
                >
                  <PlusCircle size={12} className="mr-1" /> Add Tasks
                </Button>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default Tasks;
